export enum FormControlName {
  MediaConsumo = 'mediaConsumo',
  Estado = 'estado',
  Cidade = 'cidade',
  Nome = 'nome',
  Telefone = 'telefone',
  Email = 'email',
}

export interface SelectInputOption {
  label: string;
  value: string;
}
